export default "__VITE_ASSET__fgbjjVD$__"